// extracted by mini-css-extract-plugin
module.exports = {"links":"SocialLinks_links__o9E_w","text":"SocialLinks_text__2lCpY"};